import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteData, getData, getDataById, postData, postDataWithParams, updateData } from "../../../service/Service";

const initialState = {
  data: {
    docs: [],
  },
  updatedTime: 0,
  isLoading: true,
  isError: "",
  message: "",
  postMessage: "",
  postStatus: "",
  deleteMessage: "",
  deleteStatus: "",
  updateMessage: "",
  updateStatus: "",
};

export const getStockOperationalGoods = createAsyncThunk(
  "admin/stock-operational-goods",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getData("/admin/stock-operational-goods", data.token, data.params);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getStockOperationalGoodsById = createAsyncThunk(
  "admin/stock-operational-goods/id",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getDataById("/admin/stock-operational-goods/", data.token, data.id);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const sortStockOperationalGoods = createAsyncThunk(
  "admin/stock-operational-goods/sort",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postDataWithParams(
        "/admin/stock-operational-goods/search",
        data.token,
        data.body,
        data.params
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const postStockOperationalGoods = createAsyncThunk(
  "admin/stock-operational-goods/post",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postData("/admin/stock-operational-goods", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteStockOperationalGoods = createAsyncThunk(
  "admin/stock-operational-goods/delete",
  async (data, { rejectWithValue }) => {
    try {
      const result = await deleteData("/admin/stock-operational-goods/", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const updateStockOperationalGoods = createAsyncThunk(
  "admin/stock-operational-goods/edit",
  async (data, { rejectWithValue }) => {
    try {
      const result = await updateData(
        "/admin/stock-operational-goods/",
        data.token,
        data.id,
        data.value
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);


const stockOperationalGoodsSlice = createSlice({
  name: "Stock Vegetables Store",
  initialState: initialState,
  reducers: {
    addStockOperationalGoods(state, action) {
      state.data.docs.unshift(action.payload);
    },
    sortStockOperationalGoods(state, action) {
      state.data.docs = action.payload;
    },
    deleteStockOperationalGoods(state, action) {
      state.data.docs = state.data.docs.filter(
        (item) => item._id !== action.payload
      );
    },
    editStockOperationalGoods(state, action) {
      let x = state.data.docs.findIndex((item) => item._id === action.payload._id);
      state.data.docs[x] = action.payload;
    },
  },
  extraReducers: {
    [getStockOperationalGoods.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getStockOperationalGoods.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.updatedTime = Date.now();
      state.message = action.payload.message;
    },
    [getStockOperationalGoods.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getStockOperationalGoodsById.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getStockOperationalGoodsById.fulfilled]: (state, action) => {
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getStockOperationalGoodsById.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortStockOperationalGoods.pending]: (state, ) => {
      state.isLoading = true;
    },
    [sortStockOperationalGoods.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortStockOperationalGoods.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [postStockOperationalGoods.pending]: (state, ) => {
      state.isLoading = true;
    },
    [postStockOperationalGoods.fulfilled]: (state, action) => {
      state.postMessage = action.payload.message;
      state.postStatus = action.payload.status;
    },
    [postStockOperationalGoods.rejected]: (state, action) => {
      state.isError = true;
      state.postMessage = action.payload.message;
    },
    [deleteStockOperationalGoods.pending]: (state, ) => {
      state.isLoading = true;
    },
    [deleteStockOperationalGoods.fulfilled]: (state, action) => {
      state.deleteMessage = action.payload.message;
      state.deleteStatus = action.payload.status;
    },
    [deleteStockOperationalGoods.rejected]: (state, action) => {
      state.isError = true;
      state.deleteMessage = action.payload.message;
    },
    [updateStockOperationalGoods.pending]: (state, ) => {
      state.isLoading = true;
    },
    [updateStockOperationalGoods.fulfilled]: (state, action) => {
      state.updateMessage = action.payload.message;
      state.status = action.payload.status;
    },
    [updateStockOperationalGoods.rejected]: (state, action) => {
      state.isError = true;
      state.updateMessage = action.payload.message;
    },
  },
});

export const stockOperationalGoodsActions = stockOperationalGoodsSlice.actions;

export default stockOperationalGoodsSlice.reducer;
